module.exports = __webpack_public_path__ + "img/693.04c6414a.jpg";